import { render, staticRenderFns } from "./FeedSidebarIconContainer.vue?vue&type=template&id=bffeedba&scoped=true&"
var script = {}
import style0 from "./FeedSidebarIconContainer.vue?vue&type=style&index=0&id=bffeedba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffeedba",
  null
  
)

export default component.exports